import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import * as AppState from '../../../AppState';
import {
	buildPropertyDetailsUrlWithPrevUrl,
  isCapCenterOffice,
	isCapCenterListOffice
} from '../../../utilities/util';
import { CapCenterMarkerIcon, DefaultMarkerIcon } from '../MapMarkers/MapMarkerIcons';
import { Property } from '../../../interfaces/interfaces';

import Colors from '../../Shared/Colors';

import './Markers.scss';
import CapcenterIcon from '../MapMarkers/CapCenterIcon';

export const MapMarker = (props: { property: Property; lat: number; lng: number; price: string }) => {
	const gsHoveredElement = useRecoilValue(AppState.gsHoveredElement);
	const [animateMarker, setAnimateMarker] = useState(false);
	const setGsClickedMarker = useSetRecoilState(AppState.gsClickedMarker);
	const gsIsMobile = useRecoilValue(AppState.gsIsMobile);
	const navigate = useNavigate();

	const { property, lat, lng, price } = props;
	const { id, BuyerOfficeMlsId, ListOfficeMlsId, ListOfficeName, CloseDate, OffMarketTimestamp, StandardStatus, OriginatingSystemName } = property;

	useEffect(() => {
		if (gsHoveredElement[0] === id) {
			setAnimateMarker(true);
		} else {
			setAnimateMarker(false);
		}
	}, [gsHoveredElement, id]);

	const isCapCenterProperty = isCapCenterListOffice(ListOfficeName, ListOfficeMlsId, OriginatingSystemName) || isCapCenterOffice(BuyerOfficeMlsId, OriginatingSystemName);

	const isPending = (StandardStatus?.toLowerCase() === 'pending' || StandardStatus?.toLowerCase() === 'under contract');
	const isRecentlySold = (CloseDate || OffMarketTimestamp) && (StandardStatus?.toLowerCase() !== 'active') || isPending;

	return (
		<div
			id={`map-marker__wrapper--${id}`}
			key={`${lat}-${lng}`}
			className={classNames(
				'map-marker__wrapper',
				isCapCenterProperty && 'capcenter-property',
				animateMarker && 'animate-marker',
			)}
			onClick={() => {
				if (gsIsMobile) navigate(buildPropertyDetailsUrlWithPrevUrl(property));
				setGsClickedMarker(id ? id : '');
			}}
		>
			<div
				id={`marker-label--${id}`}
				className={classNames(
					id,
					'map-marker__label',
					isCapCenterProperty ? 'map-marker__label--cc-label' : 'map-marker__label--default',
					animateMarker && 'animate-marker',
					isRecentlySold && 'recently-sold',
					isPending && 'pending',
				)
				}>
				{isCapCenterProperty && (
					<div className="map-marker-icon--capcenter me-2">
						<CapcenterIcon fill={animateMarker ? (isCapCenterProperty ? '#ffffff' : Colors.brand400) : '#FFFFFF'} />
					</div>)
				}
				{price}
			</div>
			<svg
				id={`marker-svg--${id}`}
				className="map-marker__svg"
				width={isCapCenterProperty ? '74' : '46'}
				height="28"
				viewBox={`0 0 ${isCapCenterProperty ? '74' : '46'} 28`}
				fill={isCapCenterProperty ? '#FFFFFF' : 'none'}
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"

					d={isCapCenterProperty ? CapCenterMarkerIcon : DefaultMarkerIcon}
					fill={animateMarker ? (isCapCenterProperty ? Colors.brand400 : '#FFFFFF') : (isCapCenterProperty ? Colors.brand400 : (isRecentlySold ? Colors.slate300 : '#3BB1BC'))}
					stroke={animateMarker ? (isCapCenterProperty ? Colors.brand400 : (isRecentlySold ? Colors.slate500 : '#3BB1BC')) : (isCapCenterProperty ? Colors.brand500 : (isRecentlySold ? Colors.slate500 : '#3BB1BC'))}
				/>
			</svg>
		</div>
	);
};
